// Shared design constants — single source of truth
export const GOLD = "var(--theme-accent)";

/** Wordmark / mark-only brand colors (distinct from legacy UI `GOLD`). */
export const BRAND_GOLD = "#e5b547";
export const BRAND_NEAR_BLACK = "#0a0a0a";
export const BRAND_OFF_WHITE = "#f5f5f5";
export const GREEN = "#4ade80";
export const BLUE = "#60a5fa";
export const RED = "#f87171";
export const YELLOW = "#fbbf24";
export const LIME = "#a3e635";
export const LIGHT_BLUE = "#93c5fd";

export const DEAL_COLORS = {
  great: { fg: GREEN, bg: "rgba(74,222,128,0.10)" },
  good:  { fg: LIME,  bg: "rgba(163,230,53,0.10)" },
  fair:  { fg: YELLOW, bg: "rgba(251,191,36,0.10)" },
};

export const STATUS_COLORS = {
  active:  { fg: GREEN,  bg: "rgba(74,222,128,0.1)" },
  paused:  { fg: YELLOW, bg: "rgba(251,191,36,0.1)" },
  pending: { fg: BLUE,   bg: "rgba(96,165,250,0.1)" },
  sold:    { fg: "rgba(var(--c-on-bg),0.4)", bg: "rgba(var(--c-on-bg),0.06)" },
};

export const FONT = {
  heading: "'Noto Sans',sans-serif",
  body: "'DM Sans',sans-serif",
  arabic: "'Tajawal',sans-serif",
};

export const RADIUS = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
};

/**
 * Sanitize a WhatsApp number: strip non-digits, enforce length.
 * Returns empty string if invalid — callers should guard on truthy.
 */
export function sanitizeWhatsApp(raw) {
  if (!raw || typeof raw !== "string") return "";
  const digits = raw.replace(/\D/g, "");
  // Valid international phone numbers are 7-15 digits
  if (digits.length < 7 || digits.length > 15) return "";
  return digits;
}

/**
 * Build a safe wa.me URL. Returns null if the number is invalid.
 */
export function whatsAppUrl(number, message = "") {
  const clean = sanitizeWhatsApp(number);
  if (!clean) return null;
  const base = `https://wa.me/${clean}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

// Allowed redirect paths (for login ?next= validation)
export const ALLOWED_REDIRECTS = [
  "/listings", "/sell", "/dealers", "/account", "/dashboard",
  "/account/listings", "/account/saved",
  "/dashboard/listings", "/dashboard/analytics", "/dashboard/billing", "/dashboard/profile",
];
